import { render, staticRenderFns } from "./SendMessageForm.vue?vue&type=template&id=f8cb50da&scoped=true&"
import script from "./SendMessageForm.vue?vue&type=script&lang=js&"
export * from "./SendMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageForm.vue?vue&type=style&index=0&id=f8cb50da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cb50da",
  null
  
)

export default component.exports